import { TASKS } from '../i18n/el';

// Ο κανόνας «ποιος αλλάζει την κατάσταση ενός καθηκόντος», σε **ένα** σημείο.
//
// **Γιατί μετακόμισε εδώ (Σετ Β).** Ζούσε μη εξαγόμενος μέσα στον διάλογο του
// καθηκόντος, δηλαδή ήταν ορατός σε έναν καταναλωτή και **έτοιμος να αντιγραφεί**
// από τον δεύτερο. Ο πίνακας Kanban είναι ο δεύτερος: χρειάζεται την ίδια
// απόφαση για να αποφασίσει αν μια κάρτα σύρεται και αν φέρει επιλογέα.
//
// Δύο αντίγραφα του ίδιου κανόνα αποκλίνουν σιωπηλά — και εδώ η απόκλιση δεν θα
// ήταν ενοχλητική αλλά **έλεγχος πρόσβασης που δείχνει κουμπί το οποίο θα
// απορριφθεί**: ο χρήστης σύρει την κάρτα, η κάρτα γυρίζει πίσω, και το μόνο που
// μαθαίνει είναι ότι «κάτι δεν δούλεψε».
//
// ⚠ **Δεν είναι φράχτης.** Ο φράχτης είναι ο εξυπηρετητής, που επιβάλλει τη
// φράση «που του έχουν ανατεθεί» του Πίνακα 1 πριν γράψει οτιδήποτε. Εδώ
// κρίνεται μόνο **τι εμφανίζεται**, δηλαδή ευχρηστία.

/** Ο κανόνας του Πίνακα 1: «ενημέρωση καθηκόντων **που του έχουν ανατεθεί**». */
export function isAssignee(task, userId) {
  if (!userId) return false;
  return (task?.assignees ?? []).some((user) => String(user?.id ?? user) === String(userId));
}

/**
 * Μπορεί αυτός ο χρήστης να μεταβάλει την **πρόοδο** αυτού του καθηκόντος;
 *
 * Ο ανάδοχος ή όποιος έχει διαχείριση καθηκόντων στη συλλογή. Το `canManage`
 * έρχεται από τον καλούντα, γιατί προκύπτει από τον ρόλο **στη συλλογή του
 * καθηκόντος** — και στη διασυλλογική οθόνη κάθε καθήκον έχει άλλη.
 */
export function mayProgress(task, { userId, canManage = false } = {}) {
  return canManage === true || isAssignee(task, userId);
}

/**
 * Οι καταστάσεις, **διαβασμένες** από τον κατάλογο των ετικετών.
 *
 * Δεν απαριθμούνται εδώ, και δεν απαριθμούνται ούτε στον πίνακα Kanban: οι
 * στήλες του **είναι** αυτός ο κατάλογος. Η ταύτισή του με το σχήμα του
 * διακομιστή —όνομα προς όνομα **και σειρά προς σειρά**— ελέγχεται από το
 * `taskStatuses.test.js`, γιατί δύο αντίγραφα ενός καταλόγου σε δύο πακέτα δεν
 * τα βλέπει κανένας μεταγλωττιστής.
 */
export const TASK_STATUS_KEYS = Object.freeze(Object.keys(TASKS.status));

export default { isAssignee, mayProgress, TASK_STATUS_KEYS };
